import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useRouter } from "next/router";
import HideIf from "util/HideIf";
import { filterSummaryAppliedFiltersHandler } from "util/category/filter-summary-applied-filters-handler";
import { getURLAfterClearAllClicked } from "util/category/getURLAfterClearAllClicked";
import { filterRenderKeys } from "./filterRenderKeys";

export default function ClearAllFilter(props: any) {
  const {
    nbcFilterableAttributes, appliedFilters, className = "", children,
  } = props;

  const router = useRouter();
  const VALID_NBC_FILTERS = nbcFilterableAttributes?.map((el) => el.attributeName);
  const renderKeys = filterRenderKeys(filterSummaryAppliedFiltersHandler(appliedFilters), VALID_NBC_FILTERS);

  function handleClearAll() {
    const { href, asPath } = getURLAfterClearAllClicked();
    router.push(href, asPath)
      .then(() => window.scrollTo(0, 0));
  }

  return (
    <HideIf show={(renderKeys && renderKeys.length > 0)}>
      <div className="d-flex items-center justify-content-between p-5">
        {children}
        <PAText
          component="div"
          role="button"
          tabIndex="-1"
          fontSize={FONT_SIZE[0]}
          color="success-secondary"
          className={className}
          onClick={handleClearAll}
        >
          Clear All
        </PAText>
      </div>
    </HideIf>
  );
}
